import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setOrderpomappingFilterCriteria } from 'store/slice/PharmaSlice';

export default function OrderpomappingFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.orderpomappingDashboard);
    
    
const updateOrderidCriteria = (orderid) =>{
        dispatch(setOrderpomappingFilterCriteria(
            {
                ...filterCriteria,
                orderid:orderid
        }))
    }
const updatePoidCriteria = (poid) =>{
        dispatch(setOrderpomappingFilterCriteria(
            {
                ...filterCriteria,
                poid:poid
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Orderid"
                            name="orderid"
                            value={filterCriteria.orderid}
                            onChange={(e)=>updateOrderidCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Poid"
                            name="poid"
                            value={filterCriteria.poid}
                            onChange={(e)=>updatePoidCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}